// ##############################
// // // RegularCard styles
// #############################

import {
  card,
  cardHeader,
  defaultFont,
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  roseCardHeader
} from "assets/jss/material-dashboard-pro-react.jsx";

const headerCardStyle = {
  card:{
    overflow: "unset",
    marginLeft: "5px",
    marginRight: "5px"
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardHeader: {
    ...cardHeader,
    display: "inline-block",
    textAlign: "center"
  },
  cardPlainHeader: {
    marginLeft: 0,
    marginRight: 0
  },
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  roseCardHeader,
  cardTitle: {
    paddingBottom: "15px",
    marginTop: "0",
    marginBottom: "3px",
    color: "#3C4858",
    textDecoration: "none"
  },
  cardIcon: {
    width: "40px",
    height: "36px",
    fill: "#fff"
  },
  cardSubtitle: {
    marginBottom: "0",
    color: "rgba(255, 255, 255, 0.62)",
    fontSize: "14px"
  },
  cardActions: {
    padding: "14px",
    display: "block",
    height: "auto"
  },
  cardAvatar: {
    margin: '10px 8px 10px',
    display: 'flex',
  },
  cardContent: {
    "padding-top": "0px",
    "padding-bottom": "0px",
    "overflow-x": "scroll"
  },
  left: {
    textAlign: "left"
  },
  right: {
    textAlign: "right"
  },
  center: {
    textAlign: "center"
  }
};

export default headerCardStyle;


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/components/customHeaderCardStyle.jsx